import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { OkAloneService } from '../ok-alone.service';

@Injectable({
  providedIn: 'root'
})
export class AccountGuard implements CanActivate {

  constructor(public okService:OkAloneService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if(!this.okService.session.cid){
      if(this.okService.billing){
        if(this.okService.billing.cancelled){
          this.router.navigateByUrl('/account/trial');
          return false;
        }else if(this.okService.billing.trial_over){
          this.router.navigateByUrl('/account/trial');
          return false;
        }
      }
    }

    return true;
  }
  
}
